const APIprefix = process.env && process.env.REACT_APP_BFF_API;
const APIprefix_2 = process.env && process.env.REACT_APP_BFF_API_2;
const partnerPrefix = process.env && process.env.REACT_APP_PARTNER_URL;

export const gAPI_About_Property = `${APIprefix}/api/bot-response/about-property-response`;
export const gAPI_Property_Facilities = `${APIprefix}/api/bot-response/property-facilities-response`;
export const gAPI_Room_Amenities = `${APIprefix}/api/bot-response/room-amenities-response`;
export const gAPI_Property_Contact = `${APIprefix}/api/bot-response/property-contact-response`;
export const gAPI_Property_Activities = `${APIprefix}/api/bot-response/property-activities-response`;
export const gAPI_Property_Location = `${APIprefix}/api/bot-response/property-location-response`;
export const gAPI_Property_Front_Desk = `${APIprefix}/api/bot-response/property-front-desk-response`;
export const gAPI_Response_Test = `${APIprefix}/api/bot-response/test-response`;
export const gAPI_Special_Emergenices = `${APIprefix}/api/bot-response/special-emergencies-response`;
export const gAPI_RH_About_Property = `${APIprefix}/api/bot-response/about-rhproperty-response`;
export const postAPI_Create_A_Message = `${APIprefix}/api/bot-response/messages`;
export const putAPI_Update_Response = `${APIprefix}/api/bot-response/update-response`;
export const putAPI_Delete_Response = `${APIprefix}/api/bot-response/delete`;
export const gAPI_Response_RelatedTopics = `${APIprefix}/api/bot-response/related-topics-response`;
export const gAPI_Response_AssistantOptions = `${APIprefix}/api/bot-response/assistant-setup-response`;
export const gAPI_Response_HotelAssistantOptions = `${APIprefix}/api/bot-response/hotel-assistant-setup-response`;
export const gAPI_Response_By_Code = `${APIprefix}/api/bot-response/response`;
export const gAPI_Response_SalonInformation = `${APIprefix}/api/bot-response/salon-information-response`;
export const gAPI_Response_SalonServices = `${APIprefix}/api/bot-response/salon-services-response`;
export const gAPI_Response_SalonAssistantOptions = `${APIprefix}/api/bot-response/salon-assistant-setup-response`;
export const gAPI_Response_HPContact = `${APIprefix}/api/bot-response/hp-contact-response`;
export const gAPI_Response_HPLocation = `${APIprefix}/api/bot-response/hp-location-response`;
export const gAPI_Response_HPFacilities = `${APIprefix}/api/bot-response/hp-facilities-response`;
export const gAPI_Response_HPInformation = `${APIprefix}/api/bot-response/hp-information-response`;
export const gAPI_Response_HPAssistantOptions = `${APIprefix}/api/bot-response/hp-assistant-setup-response`;
export const gAPI_Response_QbotInformation = `${APIprefix}/api/bot-response/qbot-property-information-response`;
export const gAPI_Response_QbotAssistantOptions = `${APIprefix}/api/bot-response/qbot-assistant-setup-response`;
export const gAPI_Response_HHInformation = `${APIprefix}/api/bot-response/hh-property-information-response`;
export const gAPI_Response_HHAssistantOptions = `${APIprefix}/api/bot-response/hh-assistant-setup-response`;
export const gAPI_Response_HHAmenties = `${APIprefix}/api/bot-response/hh-amenities-response`;
export const gAPI_Response_HHPolicies = `${APIprefix}/api/bot-response/hh-policies-response`;
export const gAPI_Property_List = `${APIprefix_2}/api/property`;
export const gAPI_Response_VVNAssistantOptions = `${APIprefix}/api/bot-response/vvn-assistant-setup-response`;
export const gAPI_Response_VVNInformation = `${APIprefix}/api/bot-response/vvn-information-response`;
export const gAPI_Response_Details = `${APIprefix}/api/bot-response/response-code-details`;
export const gAPI_Response_DCAssistantOptions = `${APIprefix}/api/bot-response/dc-assistant-setup-response`;
export const gAPI_Response_DCInformation = `${APIprefix}/api/bot-response/dc-information-response`;
export const gAPI_Response_DCVoice = `${APIprefix}/api/bot-response/dc-voice-response`;
export const gAPI_Response_GolfProperty = `${APIprefix}/api/bot-response/golf-property`;
export const gAPI_Response_GolfServices = `${APIprefix}/api/bot-response/golf-services`;
export const gAPI_Response_GolfGeneral = `${APIprefix}/api/bot-response/golf-general`;
export const gAPI_Response_NorthableAbout = `${APIprefix}/api/bot-response/northable-about`;
export const gAPI_Response_NorthableEquipment = `${APIprefix}/api/bot-response/northable-equipment`;
export const gAPI_Response_NorthableHelpLine = `${APIprefix}/api/bot-response/northable-helpline`;
export const gAPI_Response_ActAssistantSetup = `${APIprefix}/api/bot-response/activities-assistant-setup-response`;
export const gAPI_Response_ActAssistantInformation = `${APIprefix}/api/bot-response/activities-assistant-information-response`;
export const gAPI_Response_GroupHotelAssistantInformation = `${APIprefix}/api/bot-response/group-hotel-assistant-setup-response`;
export const gAPI_Response_GroupHHAssistantInformation = `${APIprefix}/api/bot-response/group-hh-assistant-setup-response`;
export const gAPI_Response_RestaurantAssistantSetup = `${APIprefix}/api/bot-response/restaurant-assistant-setup-response`;
export const gAPI_Response_RestaurantAssistantInformation = `${APIprefix}/api/bot-response/restaurant-assistant-information-response`;
export const gAPI_Response_HotelChannels = `${APIprefix}/api/bot-response/hotel-channels-response`;
export const gAPI_Response_HotelBio = `${APIprefix}/api/bot-response/hotel-bio-response`;
export const gAPI_Response_CampingBio = `${APIprefix}/api/bot-response/camping-bio-response`;
export const gAPI_Response_ActivityBio = `${APIprefix}/api/bot-response/activity-bio-response`;
export const gAPI_Response_PropertyMiscellaneous = `${APIprefix}/api/bot-response/property-miscellaneous-response`;
export const gAPI_Response_UtilityPayment = `${APIprefix}/api/bot-response/utility-payments-response`;
export const gAPI_Response_UtilityBroadband = `${APIprefix}/api/bot-response/utility-broadband-response`;
export const gAPI_Response_UtilityEmergency = `${APIprefix}/api/bot-response/utility-emergency-response`;
export const gAPI_Response_UtilityMobile = `${APIprefix}/api/bot-response/utility-mobile-response`;
export const gAPI_Response_UtilityMoving = `${APIprefix}/api/bot-response/utility-moving-response`;

export const API_CloudBeds = `${APIprefix}/api/integrations/cloudBeds`;
export const API_CloudBeds_Connection = `${APIprefix}/api/cloudbeds`;
export const postAPI_Create_Ingetration = `${APIprefix}/api/integrations/create`;
export const postAPI_Create_VocuherWebiste_Ingetration = `${APIprefix}/api/integrations/voucher`;
export const gAPI_Ingetration = `${APIprefix}/api/integrations`;
export const API_Ingetration = `${APIprefix}/api/integrations`;
export const API_Ingetration_Channels = `${APIprefix}/public/integrations/channels`;
export const API_MEETING_ROOMS = `${APIprefix_2}/api/ari/meetingrooms`;
export const API_Urls = `${APIprefix_2}/api/urls`;
export const API_Sync_SABRE = `${APIprefix_2}/api/group/sync-sabre`;
export const API_RMS_SYNC_ROOMS = `${APIprefix_2}/api/groups/syncrooms`;
export const putAPI_Update_Ingetration = `${APIprefix}/api/integrations`;
export const dAPI_Delete_Ingetration = `${APIprefix}/api/integrations/delete`;
export const gAPI_Stripe_Ingetration = `${APIprefix}/api/integrations/stripe`;
export const postAPI_Create_FacebookIntegration = `${APIprefix}/api/integrations/create/facebook`;
export const postAPI_Create_PhoneIntegration = `${APIprefix}/api/integrations/create/phone`;
export const postAPI_Create_GoogleBuisnessIntegration = `${APIprefix}/api/integrations/create/google-business`;
export const postAPI_Create_RevinateIntegration = `${APIprefix}/api/integrations/create/revinate`;
export const putAPI_Update_RevinateIntegration = `${APIprefix}/api/integrations/update-revinate`;
export const postAPI_Create_FacebookIntegrationInGroupService = `${APIprefix}/api/integrationsgroup/create/facebook-in-group`;
export const postAPI_Create_GoogleBuisnessIntegrationInGroupService = `${APIprefix}/api/integrationsgroup/create/google-business-in-group`;
export const postAPI_Create_PhoneIntegrationInGroupService = `${APIprefix}/api/integrationsgroup/create/phone-in-group`;
export const postAPI_Update_FacebookIntegration = `${APIprefix}/api/integrations/update-facebook`;
export const putAPI_Update_PhoneIntegration = `${APIprefix}/api/integrations/update-phone`;
export const postAPI_Update_GoogleBusinessIntegration = `${APIprefix}/api/integrations/update-google-business`;
export const gAPI_FBIngetration = `${APIprefix}/api/integrationsgroup/facebook`;
export const gAPI_GoogleBusinessIngetration = `${APIprefix}/api/integrationsgroup/google-business`;
export const gAPI_FBIntegrationByPropertyId = `${APIprefix}/api/integrationsgroup/facebook-pages-property`;
export const putAPI_Update_Ingetration_Group = `${APIprefix}/api/integrationsgroup/facebook`;
export const dAPI_Delete_Ingetration_Group = `${APIprefix}/api/integrationsgroup/facebook`;
export const putAPI_Update_PhoneIngetration_Group = `${APIprefix}/api/integrationsgroup/phone`;
export const dAPI_Delete_PhoneIngetration_Group = `${APIprefix}/api/integrationsgroup/phone`;
export const postAPI_Update_VisitorSettings = `${APIprefix}/api/integrations/update-visitorsettings`;
export const postAPI_Update_InActivePopupSettings = `${APIprefix}/api/integrations/update-inactivepopsettings`;
export const putAPI_Update_NudgesButton = `${APIprefix}/api/integrations/update-nudgesbutton`;
export const gAPI_NudgesButtonList = `${APIprefix}/api/integrations/nudgesbutton`;

// url based nudges
export const postAPI_Create_UrlNudgeButton = `${APIprefix}/api/integrations/create-url-nudgesbutton`;
export const putAPI_Update_UrlNudgeButton = `${APIprefix}/api/integrations/update-url-nudgesbutton`;

export const putAPI_Update_OnOff = `${APIprefix}/api/integrations/update-onoff`;
export const putAPI_Update_EngagementRules = `${APIprefix}/api/integrations/update-engagementrules`;
// Wechat API's
export const gAPI_WechatIntegration = `${APIprefix}/api/integrations/wechat`;
export const postAPI_Create_WechatIngetration_Group = `${APIprefix}/api/integrationsgroup/create/wechat-in-group`;
export const gAPI_WechatIngetration_Group = `${APIprefix}/api/integrationsgroup/wechat`;
export const gAPI_Account_WechatIngetrationBy_Property_Group = `${APIprefix}/api/integrationsgroup/wechat-account-property`;

/** Amadeus Integration APIs */
export const pAPI_amadeus = `${APIprefix}/api/integrations/amadeus`;

/** SHR CRS Integration APIs */
export const API_SHR_CRS = `${APIprefix_2}/api/integrations/shr-crs`;

/** MEWS Integration APIs */
export const API_MEWS = `${APIprefix}/api/integrations/mews`;

/** RMS Integration APIs */
export const API_RMS = `${APIprefix}/api/integrations/rms`;
export const gAPI_RMS = `${partnerPrefix}/public/rms`;
export const API_RMS_Integration_Group = `${APIprefix}/api/integrationsgroup/rms`;

/** WebRTC */
export const API_Web_RTC = `${APIprefix}/api/integrations/webRTC`;

/** PhoneSuite Integration APIs */
export const API_Phone_Suite = `${APIprefix}/api/integrations/phone-suite`;

/** RESTAPI Integration APIs */
export const API_REST_API = `${APIprefix}/api/integrations/rest-api`;

/** Sales Force Integration APIs */
export const API_SALESFORCE = `${APIprefix}/api/integrations/salesforce`;
export const SALESFORCE = `${APIprefix}/api/salesforce`;

/** Booking Engin Url Integration APIs */
export const pAPI_BookingEnginUrlIntegration = `${APIprefix}/api/integrations/booking-engine-url`;
export const gAPI_BookingEnginUrlIntegration_byProperty = `${APIprefix}/api/integrations/booking-engine-url/getbyproperty`;

/** Service Standalone Page Integration APIs */
export const API_ServiceStandalonePage_Integration = `${APIprefix}/api/integrations/service-standalone`;

/** Space Standalone Page Integration APIs */
export const API_SpaceStandalonePage_Integration = `${APIprefix}/api/integrations/space-standalone`;

/** Embed Page Integration APIs */
export const API_EmbedPage_Integration = `${APIprefix}/api/integrations/service-embed`;

/** Guest Service Standalone Page Integration APIs */
export const API_StandaloneGuestServicePage_Integration = `${APIprefix}/api/integrations/guest-service-standalone`;

/** WhatsApp Integration API's */
export const API_Whatsapp_Integration = `${APIprefix}/api/integrations/whatsapp`;
export const postAPI_Whatsapp_Integration_Group = `${APIprefix}/api/integrationsgroup/create/whatsapp`;
export const API_Whatsapp_Integration_Group = `${APIprefix}/api/integrationsgroup/whatsapp`;
export const gAPI_PhoneNumber_WhatsAppIntegrationBy_Property_Group = `${APIprefix}/api/integrationsgroup/whatsapp-settings-property`;

/** Phone Suite Integration API's */
export const API_Phone_Suite_Interation_Group = `${APIprefix}/api/integrationsgroup/phonesuite`;

export const gAPI_Phone_Suite_IntegrationBy_Property_Group = `${APIprefix}/api/integrationsgroup/whatsapp-settings-property`;

/** Oracle Opera Integration API's */
export const API_OracleOpera_Integration = `${APIprefix}/api/integrations/oracle-opera`;

/** Google Analytics Integration API's */
export const API_SABRE = `${APIprefix}/api/integrations/sabre`;

/** Google Analytics Integration API's */
export const API_GooleAnalytics = `${APIprefix}/api/integrations/googleAnalytics`;

/** Help Center Integration API's */
export const API_HelpCenter_Integration = `${APIprefix}/api/integrations/helpcenter`;
export const API_HelpCenter_Group_Integration = `${APIprefix}/api/integrations/helpcenter-group`;

export const API_CopyTemplate_Integration = `${APIprefix}/api/integrations/copy-templates`;

/** Help Center Integration API's */
export const API_Email_Integration = `${APIprefix}/api/integrations/email`;

/** Amazon Integration APIs */
export const aPI_Contacts = `${APIprefix}/api/groups/contacts`;

/** Amazon Integration APIs */
export const API_AMAZON_INTEGRATION = `${APIprefix}/api/integrations/amazon`;

export const gAPI_Visitors_Stats = `${APIprefix}/api/stats/visitors`;
export const gAPI_VisitorsGroups_Stats = `${APIprefix}/api/groups/visitorstats`;
export const gAPI_CountriesGroups_Stats = `${APIprefix}/api/groups/countriestats`;
export const API_CountriesGroups_Stats = `${APIprefix_2}/api/groups/countriestats/data`;
export const gAPI_VisitorsGroupsMonth_Stats = `${APIprefix}/api/groups/visitorstatsmonth`;
export const gAPI_VisitorsGroupsContact_Stats = `${APIprefix}/api/groups/contactstats`;
export const gAPI_AvatarClick_Stats = `${APIprefix}/api/groups/avatar-click-stats`;
export const gAPI_Topics_Stats = `${APIprefix}/api/stats/topics`;
export const gAPI_Percentage_Stats = `${APIprefix}/api/stats/percentage`;
export const gAPI_Countries_Stats = `${APIprefix}/api/stats/countries`;
export const gAPI_Conversations_Stats = `${APIprefix}/api/stats/conversations`;
export const gAPI_Conversations_Night_Stats = `${APIprefix}/api/stats/conversations-night`;
export const gAPI_Conversations_VisitorQuestions = `${APIprefix}/api/stats/userquestions`;
export const gAPI_Conversations_Stats_Year = `${APIprefix}/api/stats/conversations-year`;
export const gAPI_Conversations_Night_Year_Stats = `${APIprefix}/api/stats/conversations-year-night`;
export const gAPI_AllPropertyStatsSummary = `${APIprefix}/api/stats/stats-summary-csv`;
export const gAPI_Visitors_Stats_Year = `${APIprefix}/api/stats/visitors-year`;
export const gAPI_Recommender_Stats = `${APIprefix}/api/questions/recommenderstats`;
export const gAPI_BookingEngineSearch_Stats = `${APIprefix_2}/api/ari/booking-engine-search-stats`;
export const gAPI_BookingEngineSearch_List = `${APIprefix_2}/api/ari/booking-engine-search-list`;

export const gAPI_SpaceClick_Stats = `${APIprefix_2}/api/ari/stats/space-clicks`;
export const gAPI_SpaceClick_DateWise_Stats = `${APIprefix_2}/api/ari/stats/space-click-by-date`;
export const gAPI_SpaceAvatarClick_DateWise_Stats = `${APIprefix_2}/api/ari/stats/space-avatarclick-by-date`;

export const gAPI_TicketGroup_Stats = `${APIprefix}/api/groups/ticketstats`;
export const gAPI_Ticket_Stats_ByCategory = `${APIprefix}/api/groups/ticketstats-by-category`;
export const gAPI_Number_Stats = `${APIprefix}/api/stats/number`;
export const gAPI_Conversations_Time_Stats = `${APIprefix}/api/stats/conversations-time`;
export const gAPI_Conversations_Night_Time_Stats = `${APIprefix}/api/stats/conversations-night-time`;
export const gAPI_Conversations_Time_Year_Stats = `${APIprefix}/api/stats/conversations-year-time`;
export const gAPI_Conversations_Night_Year_Time_Stats = `${APIprefix}/api/stats/conversations-year-night-time`;

export const gAPI_AdminNumberStats = `${APIprefix}/api/admin-stats/number-stats`;
export const gAPI_PropertiesDateStats = `${APIprefix}/api/admin-stats/properties-date-stats`;
export const gAPI_ChatbotCountryCount = `${APIprefix}/api/admin-stats/chatbot-counting`;
export const gAPI_PropertiesSearch = `${APIprefix}/api/admin-stats/properties-search`;

export const API_CurrencyManager = `${APIprefix}/api/currency-conversion`;

export const API_GenerateRoomURL = `${APIprefix_2}/api/room-urls`;
export const gAPI_Rooms = `${APIprefix_2}/api/room`;
export const postAPI_Create_Room = `${APIprefix_2}/api/room/create`;
export const postAPI_Update_Rooms_Images = `${APIprefix_2}/api/room/image/update`;
export const gAPI_Room_ById = `${APIprefix_2}/api/room/detail`;
export const gAPI_RoomDelete_ById = `${APIprefix_2}/api/room`;
export const postAPI_Update_Room = `${APIprefix_2}/api/room/update`;
export const gAPI_Space_Bookings_list = `${APIprefix_2}/api/ari/spacebookings-list`;
export const gAPI_Space_Booking_By_Id = `${APIprefix_2}/api/ari/spacebooking`;
export const postAPI_ConfirmSpaceBooking = `${APIprefix_2}/api/ari/spacebookings/confirm`;
export const postAPI_CancelSpaceBooking = `${APIprefix_2}/api/ari/spacebookings/cancel`;
export const postAPI_RejectSpaceBooking = `${APIprefix_2}/api/ari/spacebookings/reject`;
export const gAPI_Ari_Room = `${APIprefix_2}/api/ari`;
export const postAPI_Update_Inventory = `${APIprefix_2}/api/ari/inventory`;
export const postAPI_Update_Restrictions = `${APIprefix_2}/api/ari/restrictions`;
export const postAPI_Update_Rates = `${APIprefix_2}/api/ari/rates`;
export const postAPI_Sync_Room = `${APIprefix_2}/api/room/syncrooms`;
export const gAPI_Room_CategoryTags = `${APIprefix_2}/api/room/categorytags`;
/**
 * ARI APIs
 * */
/** Add On's APIs */
export const gAPI_AddOns_List = `${APIprefix_2}/api/ari/addons-list`;
export const gAPI_AddOns_By_Id = `${APIprefix_2}/api/ari/addons/get`;
export const postAPI_Create_AddOns = `${APIprefix_2}/api/ari/addons/create`;
export const putAPI_Update_AddOns = `${APIprefix_2}/api/ari/addons/update`;
export const putAPI_Update_AddOns_Images = `${APIprefix_2}/api/ari/addons/update-images`;
/** Promos APIs */
export const gAPI_Promos_List = `${APIprefix_2}/api/ari/promos-list`;
export const gAPI_Promos_By_Id = `${APIprefix_2}/api/ari/promos/get`;
export const postAPI_Create_Promos = `${APIprefix_2}/api/ari/promos/create`;
export const putAPI_Update_Promos = `${APIprefix_2}/api/ari/promos/update`;
export const putAPI_Update_Promos_Images = `${APIprefix_2}/api/ari/promos/update-images`;

/** Rate Plan's APIs */
export const gAPI_RatePlans_List = `${APIprefix_2}/api/ari/rateplans-list`;
export const gAPI_RatePlans_By_Id = `${APIprefix_2}/api/ari/rateplans/get`;
export const postAPI_Create_RatePlans = `${APIprefix_2}/api/ari/rateplans/create`;
export const putAPI_Update_RatePlans = `${APIprefix_2}/api/ari/rateplans/update`;
export const putAPI_Update_RatePlan_RoomMapping = `${APIprefix_2}/api/ari/rateplans/rooms-mapping`;
export const gAPI_Rooms_List = `${APIprefix_2}/api/ari/rooms-list`;
export const gAPI_RatesPlan_List_ByRoomId = `${APIprefix_2}/api/ari/rateplans-list-linked`;
export const gAPI_LinkedRoomList_ByPropertyId = `${APIprefix_2}/api/ari/roomtypes-list-linked`;

/** Bookings's APIs */
export const gAPI_Bookings_list = `${APIprefix_2}/api/ari/bookings-list`;
export const gAPI_Booking_By_Id = `${APIprefix_2}/api/ari/booking`;
export const postAPI_ConfirmBooking = `${APIprefix_2}/api/ari/bookings/confirm`;
export const postAPI_CancelBooking = `${APIprefix_2}/api/ari/bookings/cancel`;
export const postAPI_ConfirmBookingEmail = `${APIprefix_2}/public/bookings/confirmbyemail`;
/** Bookings's APIs */
export const gAPI_Conversations_list = `${APIprefix_2}/api/conversations/list`;
export const gAPI_Visitors_Conversations_list = `${APIprefix_2}/api/conversations/list/visitors`;
export const gAPI_Conversations_Activelist = `${APIprefix_2}/api/conversations/active`;
export const gAPI_Conversations_By_Id = `${APIprefix_2}/api/conversations/get`;
export const pAPI_Update_Message = `${APIprefix_2}/api/conversations/update-message`;
export const putAPI_ConversationsStatus_By_Id = `${APIprefix_2}/api/conversations/update-status`;
export const putAPI_ConversationsTwilioStart = `${APIprefix_2}/api/conversations/TwilioStart`;
export const putAPI_ConversationsTwilioEnd = `${APIprefix_2}/api/conversations/TwilioEnd`;
export const gAPI_Conversations_By_BotConversation = `${APIprefix_2}/api/conversations/getByBotConversation`;
export const gAPI_BotConversations_list = `${APIprefix_2}/api/conversations/latestbot`;
export const gAPI_AgentConversations_list = `${APIprefix_2}/api/conversations/latestagent`;
/** Groups and Properties */
export const gAPI_Groups = `${APIprefix_2}/api/groups/list`;
export const postAPI_Create_Group = `${APIprefix_2}/api/groups/create`;
export const putAPI_Update_Group = `${APIprefix_2}/api/groups/update`;
export const putAPI_UpdateStatus_Group = `${APIprefix_2}/api/groups/updatestatus`;
export const postAPI_Create_Property = `${APIprefix_2}/api/property/create`;
export const postAPI_Update_Property = `${APIprefix_2}/api/property/update`;
export const gAPI_Group_By_Id = `${APIprefix_2}/api/groups/get`;
export const gAPI_OnboardGroup_By_Id = `${APIprefix_2}/api/groups/getonboard`;
export const gAPI_Internal_Property_List = `${APIprefix_2}/api/property/internal`;
export const gAPI_Property_List_By_Group = `${APIprefix_2}/api/property/listbygroup`;
export const gAPI_Internal_Property_By_Id = `${APIprefix_2}/api/property/internal`;
export const putAPI_Update_Contacts = `${APIprefix_2}/api/property/update-contacts`;
export const gAPI_Users_LinkedProperties_By_Id = `${APIprefix_2}/api/property/linkedproperties`;
export const putAPI_Update_Property_images = `${APIprefix_2}/api/property/update-images`;
export const putAPI_Update_GptPromptTemplate = `${APIprefix_2}/api/property/update-gpt-prompt-template`;
export const API_Custom_Urls = `${APIprefix_2}/api/groups/custom-urls`;

export const putAPI_Update_Domains = `${APIprefix_2}/api/property/update-domains`;
export const putAPI_Update_DataRetention = `${APIprefix_2}/api/property/update-data-retention`;
export const putAPI_Update_HideStats = `${APIprefix_2}/api/property/update-hide-stats`;
export const postAPI_Onboard = `${APIprefix_2}/public/groups/onboard`;
export const gAPI_CheckUser_Property = `${APIprefix_2}/api/property/verifyuser`;
export const gAPI_CheckUser_Groups = `${APIprefix_2}/api/groups/verifyuser`;

/** Tickets */
export const gAPI_Tickets_list = `${APIprefix_2}/api/tickets/list`;
export const aPI_Contacts_Tickets_list = `${APIprefix}/api/tickets/conatct`;
export const gAPI_Tickets_By_Id = `${APIprefix_2}/api/tickets/get`;
export const postAPI_Create_Ticket = `${APIprefix_2}/api/tickets/create`;
export const putAPI_Update_Ticket = `${APIprefix_2}/api/tickets/update`;
export const gAPI_TicketsRecording_id = `${APIprefix_2}/api/tickets/recordingurl`;
export const postAPI_Ticket_SendText = `${APIprefix_2}/api/tickets/sendtext`;
/** Users */
export const gAPI_Users_list = `${APIprefix_2}/api/users/list`;
export const gAPI_Users_By_Id = `${APIprefix_2}/api/users/get`;
export const gAPI_LinkedGrups_By_Id = `${APIprefix_2}/api/users/linkedgroups`;
export const gAPI_Users_LinkedGrups_By_Id = `${APIprefix_2}/api/groups/linkedgroups`;
export const postAPI_Create_User = `${APIprefix_2}/api/users/create`;
export const postAPI_Update_User = `${APIprefix_2}/api/users/update`;
export const postAPI_Invite_User = `${APIprefix_2}/api/users/invite`;
export const postAPI_Verify_User = `${APIprefix_2}/public/verify`;
export const postAPI_UpdatePassword = `${APIprefix_2}/api/users`;
export const postAPI_ResetPassword = `${APIprefix_2}/public`;
export const postAPI_ForgotPassword = `${APIprefix_2}/public-user/forgot-password`;
export const postAPI_Users_ForgotPassword = `${APIprefix_2}/api/users/forgot-password`;
export const postAPI_VerifyForgotPassword = `${APIprefix_2}/public/verify-forgot-password`;
export const postAPI_VerifyPassword = `${APIprefix_2}/api/users/verify-password`;
export const postAPI_Signup_User = `${APIprefix_2}/public/signup`;
export const postAPI_ResendInvite = `${APIprefix_2}/api/users`;
export const postAPI_GenerateInvite = `${APIprefix_2}/api/users`;
export const postAPI_EmailCheck = `${APIprefix_2}/public/email-check`;
export const putAPI_AgentStatus = `${APIprefix_2}/api/users`;
export const gAPI_Search_Users_list = `${APIprefix_2}/api/users/search`;
export const gAPI_GetUsersAuditLogs_list = `${APIprefix_2}/api/users/auditlogs-list`;
export const postAPI_SaveUsersAuditLogs = `${APIprefix_2}/api/users/audit-logs-save`;

/* Services */
export const gAPI_Services = `${APIprefix_2}/api/services/list`;
export const postAPI_Create_Services = `${APIprefix_2}/api/services/create`;
export const putAPI_Update_Service = `${APIprefix_2}/api/services/update`;
export const gAPI_Service_By_Id = `${APIprefix_2}/api/services/get`;
export const putAPI_Delete_Service = `${APIprefix_2}/api/services/delete`;
export const gAPI_AllServices = `${APIprefix_2}/api/services/services-list`;
export const API_BMB_Font = `${APIprefix_2}/api/services/bmb-font`;
export const postAPI_Update_Services_DisplayOrder = `${APIprefix_2}/api/services/display-order`;
export const postAPI_Update_Services_CategoryDisplayOrder = `${APIprefix_2}/api/services/category-display-order`;
export const gAPI_Service_CategoryList = `${APIprefix_2}/api/services/categories`;
export const postAPI_Update_Service_Category = `${APIprefix_2}/api/services/update-category`;
export const gAPI_Service_Click = `${APIprefix_2}/api/services/stats/clicks`;
export const gAPI_Service_Item_Click_DateStatics = `${APIprefix_2}/api/services/stats/date-statstics`;
export const gAPI_Service_Avatar_Click_DateStatics = `${APIprefix_2}/api/services/stats/avatar-date-statstics`;

/* Email Stats */
export const API_Email_Stats = `${APIprefix_2}/api/groups/email-stats`;

/* Events Calendar */
export const gAPI_EventsList = `${APIprefix_2}/api/events-calendar/list`;
export const postAPI_EventsCreate = `${APIprefix_2}/api/events-calendar/create`;
export const putAPI_EventsUpdate = `${APIprefix_2}/api/events-calendar/update`;
export const gAPI_EventsById = `${APIprefix_2}/api/events-calendar/get`;
export const deleteAPI_EventsDelete = `${APIprefix_2}/api/events-calendar/delete`;
export const postAPI_EventsDisplayOrder = `${APIprefix_2}/api/events-calendar/display-order`;

/* Locations */
export const gAPI_Locations = `${APIprefix_2}/api/locations/list`;
export const postAPI_Create_Location = `${APIprefix_2}/api/locations/create`;
export const putAPI_Update_Location = `${APIprefix_2}/api/locations/update`;
export const gAPI_Location_By_Id = `${APIprefix_2}/api/locations/get`;
export const putAPI_Delete_Location = `${APIprefix_2}/api/locations/delete`;

/* Images */
export const postAPI_User_Images = `${APIprefix_2}/api/images/user`;
export const postAPI_Bmb_Images = `${APIprefix_2}/api/images/bmb`;
export const postAPI_User_Integration_Images = `${APIprefix_2}/api/images/integration-image`;
export const gAPI_UserUploads = `${APIprefix_2}/api/images/user-uploads`;
export const gAPI_BmbUploads = `${APIprefix_2}/api/images/bmb-uploads`;
export const putAPI_Update_Image = `${APIprefix_2}/api/images/update`;
export const putAPI_Delete_Image = `${APIprefix_2}/api/images/delete`;
export const postAPI_User_External_Images = `${APIprefix_2}/api/images/user-uploads-external`;
export const postAPI_User_Website_Images = `${APIprefix_2}/api/images/user-uploads-website`;

/* Json */
export const postAPI_Json_Upload = `${APIprefix_2}/api/questions/invoke-api/upload`;

/** Svg Gallery */
export const postAPI_User_SvgGallery = `${APIprefix_2}/api/images/svg-gallery/user`;
export const postAPI_Bmb_SvgGallery = `${APIprefix_2}/api/images/svg-gallery/bmb`;
export const postAPI_User_External_SvgGallery = `${APIprefix_2}/api/images/svg-gallery/user-uploads-external`;
/* Templates */
export const gAPI_TemplatePromoList = `${APIprefix_2}/api/templates/list-template-promos`;
export const gAPI_CopyPromo = `${APIprefix_2}/api/templates/copy-promos`;
export const gAPI_TemplateAddOnList = `${APIprefix_2}/api/templates/list-template-addons`;
export const gAPI_CopyAddOn = `${APIprefix_2}/api/templates/copy-addons`;
export const gAPI_TemplateServicesList = `${APIprefix_2}/api/templates/list-template-services`;
export const gAPI_CopyServices = `${APIprefix_2}/api/templates/copy-services`;

/** Guests */
export const gAPI_Guests_List = `${APIprefix_2}/api/ari/checkinguests-list`;
export const gAPI_Guests_By_Id = `${APIprefix_2}/api/ari/checkinguests/get`;
export const postAPI_Create_Guests = `${APIprefix_2}/api/ari/checkinguests/create`;
export const putAPI_Update_Guests = `${APIprefix_2}/api/ari/checkinguests/update`;
export const dAPI_Delete_Guests = `${APIprefix_2}/api/ari/checkinguests/delete`;

/**Products */
export const gAPI_Products_List = `${APIprefix_2}/public/products/list`;

/**Unsubscribe */
export const dAPI_Unsubscribe = `${APIprefix_2}/public/property/unsubscribe-contact`;

/* Subscription */
export const gAPI_Subscription_By_Group_Id = `${APIprefix_2}/api/subscriptions/get`;
export const postAPI_Create_Subscription = `${APIprefix_2}/api/subscriptions/create`;
export const putAPI_Update_Subscription = `${APIprefix_2}/api/subscriptions/update`;
export const gAPI_Subscription_By_Id = `${APIprefix_2}/api/subscriptions/get`;
export const putAPI_Delete_Subscription = `${APIprefix_2}/api/subscriptions/delete`;

/* Questions */
export const gAPI_QuestionSets = `${APIprefix_2}/api/questions/set/list`;
export const postAPI_Create_QuestionSet = `${APIprefix_2}/api/questions/set/create`;
export const putAPI_Update_QuestionSet = `${APIprefix_2}/api/questions/set/update`;
export const postAPI_Update_QuestionSet_DisplayOrder = `${APIprefix_2}/api/questions/set/update-display-order`;
export const gAPI_QuestionSet_By_Id = `${APIprefix_2}/api/questions/set/get`;
export const putAPI_Delete_QuestionSet = `${APIprefix_2}/api/questions/set/delete`;

export const postAPI_Create_Question = `${APIprefix_2}/api/questions/question/create`;
export const putAPI_Update_Question = `${APIprefix_2}/api/questions/question/update`;
export const postAPI_Update_Question_DisplayOrder = `${APIprefix_2}/api/questions/question/update-display-order`;
export const gAPI_Question_By_Id = `${APIprefix_2}/api/questions/question/get`;
export const putAPI_Delete_Question = `${APIprefix_2}/api/questions/question/delete`;
export const gAPI_Question_MessagesList = `${APIprefix_2}/api/questions/question/messages-list`;
export const putAPI_Update_Question_Tags = `${APIprefix_2}/api/questions/question/update-tags`;

export const postAPI_Create_Question_Option = `${APIprefix_2}/api/questions/questionoption/create`;
export const putAPI_Update_Question_Option = `${APIprefix_2}/api/questions/questionoption/update`;
export const postAPI_Update_Question_Option_DisplayOrder = `${APIprefix_2}/api/questions/questionoption/update-display-order`;
export const gAPI_Question_Option_By_Id = `${APIprefix_2}/api/questions/questionoption/get`;
export const putAPI_Delete_Question_Option = `${APIprefix_2}/api/questions/questionoption/delete`;
export const gAPI_QuestionOptionList = `${APIprefix_2}/api/questions/questionoption/list`;
export const postAPI_QuestionOption_AllList = `${APIprefix_2}/api/questions/question-option-list`;
/* products */
export const gAPI_Business = `${APIprefix_2}/api/propertyproduct/list`;
export const postAPI_Create_Business = `${APIprefix_2}/api/propertyproduct/create`;
export const putAPI_Update_Business = `${APIprefix_2}/api/propertyproduct/update`;
export const gAPI_Business_By_Id = `${APIprefix_2}/api/propertyproduct/get`;
export const putAPI_Delete_Business = `${APIprefix_2}/api/propertyproduct/delete`;
export const gAPI_Search_Business = `${APIprefix_2}/api/propertyproduct/category-tags`;

export const gAPI_QuickReplies = `${APIprefix_2}/api/quick-replies/list`;
export const gAPI_QuickReplies_By_Type = `${APIprefix_2}/api/quick-replies/list/type`;
export const gAPI_QuickReplies_listByGroup = `${APIprefix_2}/api/quick-replies/listByGroup`;
export const postAPI_Create_QuickReply = `${APIprefix_2}/api/quick-replies/create`;
export const putAPI_Update_QuickReply = `${APIprefix_2}/api/quick-replies/update`;
export const gAPI_QuickReply_ById = `${APIprefix_2}/api/quick-replies/get`;
export const gAPI_QuickReplyDelete_ById = `${APIprefix_2}/api/quick-replies/delete`;

export const gAPI_BotDialogFile = `${APIprefix_2}/api/botdialog/file`;
export const postAPI_BotDialogFile = `${APIprefix_2}/api/botdialog/file`;
export const postAPI_UploadBotDialogFile = `${APIprefix_2}/api/botdialog/upload`;

/** Vouchers APIs */
export const gAPI_Vouchers_List = `${APIprefix_2}/api/vouchers/list`;
export const gAPI_Vouchers_By_Id = `${APIprefix_2}/api/vouchers/get`;
export const postAPI_Create_Vouchers = `${APIprefix_2}/api/vouchers/create`;
export const putAPI_Update_Vouchers = `${APIprefix_2}/api/vouchers/update`;

export const postAPI_TrackEvent = `${APIprefix}/api/stats/track-activecampaign`;

export const gAPI_Favourite = `${APIprefix}/api/bot-response/favourite-response`;
export const postAPI_Favourite = `${APIprefix}/api/favourite-response`;
export const post_API_Send_Email = `${APIprefix_2}/api/groups/email`;
export const putAPI_approve_voucher = `${APIprefix_2}/api/vouchers/approve`;
export const postAPI_Invitation = `${APIprefix_2}/api/vouchers/invite/add`;
export const putAPI_Invitation = `${APIprefix_2}/api/vouchers/invite/update`;
export const gAPI_Invitation_By_Email = `${APIprefix_2}/api/vouchers/invitation/get`;
export const gAPI_Invitation_By_Property = `${APIprefix_2}/api/vouchers/invitation`;
export const gAPI_Check_Invitation = `${APIprefix_2}/api/vouchers/invitation/email`;
export const putAPi_Accept_Invitation = `${APIprefix_2}/api/vouchers/connected`;

export const postAPI_Voucher_Stats = `${APIprefix_2}/api/vouchers/stats`;
export const gAPI_Voucher_Stats = `${APIprefix_2}/api/vouchers/stats`;
export const gAPI_Voucher_Country_Stats = `${APIprefix_2}/api/vouchers/countriestats`;
export const gAPI_Voucher_Engine_Stats = `${APIprefix_2}/api/vouchers/voucherengine/stats`;
export const gAPI_Voucher_Engine_Sales = `${APIprefix_2}/api/vouchers/voucherengine/sales`;

/** Stripe APIs */
export const gAPI_Stripe_Connection = `${APIprefix_2}/public/stripe`;
export const gAPI_Voucher_Payment = `${APIprefix_2}/api/payments`;
export const gAPI_Stripe_PromoCode = `${APIprefix_2}/public/stripe/validpromo`;

export const gAPI_Orders_Voucher = `${APIprefix_2}/api/orders`;
/** Widget APIs */
export const gAPI_WidgetBy_PropertyId = `${APIprefix}/api/widgets`;
export const gAPI_WidgetById = `${APIprefix}/api/widgets/detail`;
export const postAPI_Create_Widget = `${APIprefix}/api/widgets/create`;
export const putAPI_Update_Widget = `${APIprefix}/api/widgets/update`;
export const dAPI_Delete_Widget = `${APIprefix}/api/widgets/delete`;
export const putAPI_UpdateList_Widget = `${APIprefix}/api/widgets/update-list`;
export const putAPI_UpdatePositionList_Widget = `${APIprefix}/api/widgets/update-position-list`;

/** Predict APIs */
export const gAPI_GetPlace_Predict = `${APIprefix}/api/predict/place`;
export const gAPI_GetEvent_By_Place_Predict = `${APIprefix}/api/predict/event/place`;
export const gAPI_GetEvent_By_Miles_Predict = `${APIprefix}/api/predict/event/miles`;
export const gAPI_GetEvent_By_Country_Predict = `${APIprefix}/api/predict/event/country`;

export const putAPI_ConversationsFacebookTransfer = `${APIprefix_2}/api/conversations/FacebookTransfer`;
export const putAPI_UpdateAgentStatus_By_Id = `${APIprefix_2}/api/conversations/update-agent-status`;
export const putAPI_UpdateChatStatus_By_Id = `${APIprefix_2}/api/conversations/update-chat-status`;
export const gAPI_MissingBotResponse = `${APIprefix}/api/bot-response/missing-response`;
export const gAPI_PropertiesBotResponseByCode = `${APIprefix}/api/bot-response/property-response-by-code`;
//export const gAPI_AllResponse = `${APIprefix}/api/bot-response/all-response`;
export const gAPI_BotResponseHistory = `${APIprefix}/api/bot-response/history`;

/* Outbound Trigger */
export const postAPI_Create_OutboundTrigger = `${APIprefix_2}/api/outbound-trigger/create`;
export const putAPI_Update_OutboundTrigger = `${APIprefix_2}/api/outbound-trigger/update`;
export const gAPI_OutboundTrigger_By_PropertyId = `${APIprefix_2}/api/outbound-trigger/list`;
export const gAPI_OutboundTrigger_By_Id = `${APIprefix_2}/api/outbound-trigger/get`;
export const deleteAPI_Delete_OutboundTrigger = `${APIprefix_2}/api/outbound-trigger/delete`;
export const gAPI_OutboundTriggerAction_By_TriggerId = `${APIprefix_2}/api/outbound-trigger/list/action`;
export const postAPI_Add_OutboundTriggerAction = `${APIprefix_2}/api/outbound-trigger/add/action`;

/** Forms */
export const postAPI_Create_Forms = `${APIprefix_2}/api/forms/create`;
export const putAPI_Update_Forms = `${APIprefix_2}/api/forms/update`;
export const putAPI_Update_Forms_Contact = `${APIprefix_2}/api/forms/update-contacts`;
export const gAPI_FormsList = `${APIprefix_2}/api/forms/list`;
export const gAPI_FormsBy_Id = `${APIprefix_2}/api/forms/get`;
export const gAPI_FormsBy_PropertyId = `${APIprefix_2}/api/forms/search`;
export const gAPI_FormsCategoryList = `${APIprefix_2}/api/forms/category-list`;
export const API_FormSettings = `${APIprefix_2}/api/forms-settings`;

/** Form Tickets */
export const gAPI_FormTickets_list = `${APIprefix_2}/api/form-tickets/list`;
export const gAPI_FormsTickets_By_Id = `${APIprefix_2}/api/form-tickets/get`;
export const putAPI_Update_FormsTickets_Status = `${APIprefix_2}/api/form-tickets/update`;
export const gAPI_FormTickets_list_By_FormId = `${APIprefix_2}/api/form-tickets/list-by-formid`;

/* Messenger */
export const gAPI_Messenger = `${APIprefix_2}/api/messenger/list`;
export const postAPI_Create_Messenger = `${APIprefix_2}/api/messenger/create`;
export const putAPI_Update_Messenger = `${APIprefix_2}/api/messenger/update`;
export const gAPI_Messenger_By_Id = `${APIprefix_2}/api/messenger/get`;
export const putAPI_Delete_Messenger = `${APIprefix_2}/api/messenger/delete`;
export const gAPI_AllMessengers = `${APIprefix_2}/api/messenger/messenger-list`;
export const postAPI_Update_Messengers_DisplayOrder = `${APIprefix_2}/api/messenger/display-order`;
export const postAPI_Update_Messengers_Category = `${APIprefix_2}/api/messenger/update-category`;
export const gAPI_Messengers_CategoryList = `${APIprefix_2}/api/messenger/categories`;
export const gAPI_Messenger_Click = `${APIprefix_2}/api/messenger/stats/clicks`;
export const gAPI_Messenger_DateWiseStats = `${APIprefix_2}/api/messenger/stats/date-statstics`;

/** GPT PUBLISH */
export const postAPI_PublishGPT = `${APIprefix_2}/api/gpt/publish`;
export const gAPI_Publish_logs = `${APIprefix_2}/api/gpt/logs`;
export const postAPI_GPT_Query = `${APIprefix_2}/api/gpt`;

/** Business Operator GPT PUBLISH */
export const postAPI_Business_Operator_PublishGPT = `${APIprefix_2}/api/business-operator/publish`;

export const gAPI_Response_Amadeus = `${partnerPrefix}/public/amadeus`;
/** Amadus */

export const gAPI_Response_Availability = `${partnerPrefix}/public/availability`;
/** Availability */

export const Upload_Email_Attachment = `${APIprefix_2}/api/groups/email-attachment/upload`;
/** Upload Email Attachment */

export const gAPI_Response_Mews = `${partnerPrefix}/public/mews`;
/** Mews */

export const gAPI_Response_SHRCRS = `${partnerPrefix}/public/shr-crs`;
/** SHRCRS */

export const gAPI_Response_Sabre = `${partnerPrefix}/public/sabre`;
/** Sabre */

//export const getAPI_Amadeus_RoomList = `${APIprefix_2}/public/amadeus`;

/** Space Addons */
export const API_SpaceAddons = `${APIprefix_2}/api/ari/space-addons`;

/** Publish Ai Features */

export const gAPI_Publish_Features = `${APIprefix_2}/api/groups/features`;

/** FAQ Addons */
export const API_FAQ = `${APIprefix_2}/api/groups/faq`;

export const API_FAQ_Collection = `${APIprefix_2}/api/groups/faq/collection`;
/** Document Addons */
export const API_Documents = `${APIprefix_2}/api/groups/documents`;
export const API_Documents_Upload = `${APIprefix_2}/api/groups/documents/Upload`;

/** Document Addons */
export const API_Logs = `${APIprefix_2}/api/groups/logs`;

/** Deepgram Addons */
export const API_DEEPGRAM_TEXT_TO_SPPECH = `${APIprefix_2}/api/deepgram/text-to-speech`;

/** ConnectWare Addons */
export const API_CONNECTWARE = `${APIprefix_2}/api/connectware`;

/** Activate Call Flows */
export const gAPI_Call_Flows = `${APIprefix}/api/groups/ai-call-flows`;
export const postAPI_DownloadMedia = `${APIprefix}/api/groups/download`;

/** Site Settings */
export const gAPI_Site_Settings = `${APIprefix_2}/api/groups/site-settings`;
export const postAPI_Site_Settings = `${APIprefix_2}/api/groups/site-settings`;

//Billing Details
export const postApi_Billing_Details = `${APIprefix}/api/property/billing-details`;
export const postApi_Billing_Details_US = `${APIprefix}/api/property/billing-details/us`;

//Open AI Assistant
export const API_OpenAI_Assistant = `${APIprefix_2}/api/aiassitant`;
export const API_Publish_Assistant = `${APIprefix}/api/questions/publish`;
export const gAPI_ConversationSummaryByAssistant = `${APIprefix_2}/api/aiassitant/get-conversation-summary`;

export const API_INSTAGRAM_AUTH = `${APIprefix}/api/instagram`;
export const API_INSTAGRAM = `${APIprefix}/api/integrations/instagram`;

export const postAPI_User_Folder = `${APIprefix_2}/api/images/folder`;
export const putAPI_Update_Folder = `${APIprefix_2}/api/images/folder`;

/* Missed Response*/

export const gAPI_MissedResponseList = `${APIprefix_2}/api/missingresponse/list`;
export const putAPI_UpdateMissedResponseStatus = `${APIprefix_2}/api/missingresponse/update-status`;
